import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@material-ui/core';

const CheckboxBase = (props) => {
    const {
        isChecked, onClickEvent,
    } = props;
    const [isCheck, setIsCheck] = useState(isChecked);

    /**
     * @name onChangeField
     * @desc Metodo que realiza consulta al api para cambiar el valor
     * @returns {Promise<void>}
     */
    const onChangeField = async (event) => {
        const { checked } = event.target;
        setIsCheck(checked);

        if (onClickEvent) {
            onClickEvent({ check: checked });
        }
    };

    return (
      <Checkbox
        // disabled={disabledCheck}
        checked={isCheck}
        onChange={(event) => onChangeField(event)}
      />
    );
};

CheckboxBase.defaultProps = {
    onClickEvent: null,
};

CheckboxBase.propTypes = {
    // Variable que checkea el checkbox
    isChecked: PropTypes.bool.isRequired,
    // Funcion que dispara el evento de click
    onClickEvent: PropTypes.func,
};

export default CheckboxBase;
